import React from 'react';
import { motion } from 'framer-motion';
interface IntroSectionProps {
  onStart: () => void;
}
export const IntroSection: React.FC<IntroSectionProps> = ({
  onStart
}) => {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="min-h-screen bg-gradient-to-b from-lavender to-white px-6 py-16 flex flex-col items-center text-center" data-id="element-52">
      <div className="max-w-2xl w-full mx-auto flex flex-col items-center" data-id="element-53">
        <span className="bg-brand-red text-white text-sm font-bold px-4 py-1.5 rounded-full mb-8 shadow-sm" data-id="element-54">
          🧠 TEST GRATUITO — 2 minutos
        </span>

        <h1 className="text-4xl md:text-5xl font-extrabold text-dark-blue leading-tight mb-6" data-id="element-55">
          ¿Cuánto te está afectando la ansiedad realmente?
        </h1>

        <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-xl" data-id="element-56">
          Responde 10 preguntas y descubre tu nivel exacto de ansiedad.
          Totalmente gratis. Resultado inmediato.
        </p>

        <div className="w-full max-w-md aspect-square md:aspect-[4/3] relative mb-10 rounded-3xl overflow-hidden shadow-2xl" data-id="element-57">
          <img src="https://cdn.magicpatterns.com/uploads/wzhR4PCBak2UiqLz1aP3i2/a-realistic-photographic-ebook-cover_2_webpeb.jpg" alt="Mujer latina serena" className="w-full h-full object-cover" data-id="element-58" />
        </div>

        <div className="flex flex-col md:flex-row gap-4 md:gap-8 mb-12 justify-center w-full" data-id="element-59">
          <div className="flex items-center justify-center gap-2 text-dark-blue font-medium" data-id="element-60">
            <span className="text-xl" data-id="element-61">⏱️</span> Solo 2 minutos
          </div>
          <div className="flex items-center justify-center gap-2 text-dark-blue font-medium" data-id="element-62">
            <span className="text-xl" data-id="element-63">🎯</span> Resultado inmediato
          </div>
          <div className="flex items-center justify-center gap-2 text-dark-blue font-medium" data-id="element-64">
            <span className="text-xl" data-id="element-65">🔒</span> 100% privado
          </div>
        </div>

        <button onClick={onStart} className="w-full max-w-md bg-brand-red hover:bg-red-600 text-white font-bold text-lg py-5 px-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1" data-id="element-66">
          HACER EL TEST GRATIS →
        </button>

        <p className="text-gray-500 text-sm mt-4 font-medium" data-id="element-67">
          Ya lo hicieron +2,000 mujeres latinas
        </p>
      </div>
    </motion.div>;
};